import Link from "next/link";

type TeamCardProps = {
    member: {
        slug: string,
        name: string,
        title: string,
        photo: string,
    }
}

export default function TeamCard({member}:TeamCardProps) {
    return (
        <Link href={`/team/${member.slug}`}>
            <div
                className="group relative flex items-center justify-center w-[290px] h-[430px] overflow-hidden"
                style={{
                backgroundImage: `url(${member.photo})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                }}
            >
                <div className="absolute inset-0 bg-primary/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10 text-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <h3 className="text-lg font-semibold">{member.name}</h3>
                    <p className="text-sm">{member.title}</p>
                </div>
            </div>
        </Link>

        
    );
}